import * as React from 'react';
import {IconButton, ListItemIcon, ListItemSecondaryAction, ListItemText, Menu, MenuItem, Popover, withStyles, WithStyles} from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import { sharedMiscStyle } from './sharednote.style';
import { IFamilyMember } from '@app-types/websocket/family.types';
import ImgAvatar from '@components/common/avatar/ImgAvatar';
import { IAiNote, IListItem, ISharedNote } from '@app-types/websocket/sharedinfo.types';
import * as EventActions from "@services/events/event.action"
import CloseIcon from '@material-ui/icons/CloseRounded';
import DescIcon from '@material-ui/icons/SubjectRounded';
import CopyIcon from '@material-ui/icons/FileCopyOutlined';
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import DeleteIcon from '@material-ui/icons/DeleteForeverRounded';
import UndoIcon from '@material-ui/icons/UndoRounded';
import { primaryColor, styleColors } from 'src/main.style';
import { Check } from '@material-ui/icons';
import theme from 'src/theme';
import { FamilyMemberType } from '@services/family/family.constants';
import { DotsIcon } from '@icons/Dots';
import Button from '@components/common/button/Button';
import * as SharedNoteActions from '@services/sharednote/sharednote.actions';
import { connect } from 'react-redux';
import { AI_RESULT, AI_TASK_TYPE, IAiTask } from '@app-types/websocket/event.types';
import { IFinishedUpload, IUploadFile } from '@app-types/websocket/file.types';
import { handleImageUpload, mimeFromFilename } from '@helpers/uploadHelper';
import * as FileActions from '@services/file/file.actions';
import Autosize from '@components/chat/Autosize';
import { displaySuccessMessage } from '@services/user/user.actions';
import { MAX_PASTED_LIST_CHARS, parsePastedListItems } from './parsePastedListItems';
import { formatSharedNoteListForClipboard, formatSharedNoteListHtmlForClipboard } from './sharedNoteClipboard';

const stickers: string[] = ["agreement.png", "application.png", "balls-sports.png", "call.png", "car.png", "checklist.png", "contacts.png", "contract.png", "education.png", "home.png", "hygienic.png", "key.png", "meds.png", "outdoors.png", "password.png", "pet.png", "school-bag.png", "shopping-bag.png", "sleeping-bag.png", "snacks.png", "snowman.png", "sports.png", "star.png", "sunbed.png", "surprise.png", "swimming.png", "task.png", "time.png", "to-do.png", "trophy.png", "vacations.png", "4.png", "5.png", "6.png", "7.png", "8.png", "9.png"];
const services: string[] = ["atv.png", "cmore.png", "disney.png", "gplay.png", "hbo.png", "netflix.png", "prime.png", "spotify.png", "storytel.png", "streaming-tv-app.png", "via.png", "disco.png", "sf.png"];

const tn: TranslateNew = TranslateNew.getInstance();

interface IState {
  title:string;
  icon:string|undefined;
  avatarId:number|undefined;
  visibleFor:number[];
  listItems:IListItem[];
  desc:string;
  accountUsername:string;
  accountPassword:string;

  focusId?:string; // for focus management
  focusPosition?:number;

  showVisibleForSelect:boolean;
  showMenu:boolean;
  showIconSelect:boolean;
  showIconList:boolean;

  hasDesc:boolean;
  bounceTopItem: boolean,

  internalUploadId:number|undefined;

  lastSeenVersionTimestamp:number;
  history:ISharedNote[];
  undoPressed:boolean;
}

interface IProps extends WithStyles<typeof sharedMiscStyle> {
  localNotes:ISharedNote[],
  sharedNotes:ISharedNote[],
  editNoteId:number|undefined,
  family:IFamilyMember[],
  aiTasks:IAiTask[],
  aiIconTasks:IAiTask[],
  uploadedFiles: IFinishedUpload[],

  uploadFile: (file: IUploadFile) => void;
  aiTask: (task:IAiTask) => void;
  close:() => void;
  deleteSharedNote: (noteId: number) => void;
  seenSharedNote: (noteId: number) => void;
  localDel: (noteId: number) => void;
  localSave: (sharedNote: ISharedNote) => void;
  updateSharedNote: (sharedNote: ISharedNote) => void;
  prompt: () => void;
  dismissAiTask : (aiID:number) => void;
  displaySuccessMessage: (msg: string) => void;

  backgroundColor: string;
  isAccountNote:boolean;

}

class SharedNote extends React.Component<IProps, IState> {
  private iconRef: React.RefObject<HTMLDivElement> = React.createRef();
  private iconSubRef: React.RefObject<HTMLDivElement> = React.createRef();
  private menuRef: React.RefObject<HTMLButtonElement> = React.createRef();
  private visibleForRef: React.RefObject<HTMLDivElement> = React.createRef();

  private timer: NodeJS.Timeout| undefined ;

  private isDragging = false;
  private dragStartY = 0;
  private dragStartHeight = 0;

  private paneHeight:string = '0%';
  private paneRef: React.RefObject<HTMLDivElement> = React.createRef();
  private hideRef: React.RefObject<HTMLDivElement> = React.createRef();
  private scrollListRef: React.RefObject<HTMLDivElement> = React.createRef();

  private keyCounter = 0;
  private lastEnterSplitTime = 0;

  constructor(props: IProps) {
    super(props);

    this.state = this.loadData(props);
  }

  public componentWillUnmount(): void {
    if (this.timer) {clearTimeout(this.timer); this.saveNote();}
    const vv = (window as any).visualViewport;
    if (vv) {
      vv.removeEventListener('resize', this.handleViewportResize);
      vv.removeEventListener('scroll', this.handleViewportResize);
    }
  }

  public componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any): void {
    if (prevProps.editNoteId !== this.props.editNoteId) {
      this.setState(this.loadData(this.props));
      if (this.paneRef.current) {
        if (this.props.editNoteId !== undefined) {
          this.paneHeight = '100%';
        } else {
          this.paneHeight = '0%';
        }
        this.paneRef.current.style.transition = 'all 0.3s';
        this.paneRef.current.style.minHeight = this.paneHeight;
        this.paneRef.current.style.maxHeight = this.paneHeight;
        this.paneRef.current.style.height = this.paneHeight;
      }
      if (this.hideRef.current) {
        if (this.props.editNoteId !== undefined) {
          this.hideRef.current.style.opacity = "1";
        } else {
          this.hideRef.current.style.opacity = "0";
        }
      }
    }

    if (this.state.internalUploadId !== undefined) {
      const uploadedIconFile = this.props.uploadedFiles.find((f) => f.internalId === this.state.internalUploadId);
      if (uploadedIconFile !== undefined) {
        this.setState({icon: uploadedIconFile.permanentURL, avatarId: undefined, internalUploadId: undefined});
      }
    }

    if ((this.props.aiIconTasks !== prevProps.aiIconTasks || prevProps.editNoteId === undefined)
      && this.props.editNoteId !== undefined && this.props.editNoteId !== 0) {

      const aiIconTask = this.props.aiIconTasks.find((task) => task.refObject === this.props.editNoteId 
        && task.taskType === AI_TASK_TYPE.NOTE_ICON && task.status === AI_RESULT.SUCCESS);

      if (aiIconTask !== undefined && aiIconTask.result !== undefined && aiIconTask.result.length > 0 
        && aiIconTask.id !== undefined && (this.state.icon === undefined || this.state.icon === "")) {
        this.setState({icon: aiIconTask.result});
        this.props.dismissAiTask(aiIconTask.id);
      }
    }

    if (this.props.editNoteId !== undefined && this.props.editNoteId < 0 && (this.props.localNotes !== prevProps.localNotes)) {
      
      const currentNote = this.props.localNotes.find((n) => n.noteId === this.props.editNoteId);
      const prevNote = prevProps.localNotes.find((n) => n.noteId === this.props.editNoteId);
      
      if (currentNote && prevNote && currentNote.lastUpdate !== prevNote.lastUpdate) {
        const latestCopy:ISharedNote = JSON.parse(JSON.stringify(currentNote));
        const history:ISharedNote[] = this.state.history.slice(0, 10);
        history.unshift(latestCopy);
        this.setState({...this.loadData(this.props), history});
      }
    } else if (this.props.editNoteId !== undefined && this.props.editNoteId > 0 && (this.props.sharedNotes !== prevProps.sharedNotes)) {
      const currentNote = this.props.sharedNotes.find((n) => n.noteId === this.props.editNoteId);
      if (currentNote && currentNote.lastUpdate && currentNote.lastUpdate > 0) {
        if (this.state.lastSeenVersionTimestamp === -1) { // we saved this no need to update local state
          this.setState({lastSeenVersionTimestamp:currentNote.lastUpdate});
        } else if (this.state.lastSeenVersionTimestamp !== currentNote.lastUpdate) {
          const latestCopy:ISharedNote = JSON.parse(JSON.stringify(currentNote));
          const history:ISharedNote[] = this.state.history.slice(0, 10);
          history.unshift(latestCopy);
          this.setState({...this.loadData(this.props), lastSeenVersionTimestamp:currentNote.lastUpdate, history});
        }
      }
    }
    
    if (this.state.focusId !== undefined && prevState.focusId !== this.state.focusId) {

      const element = document.getElementById(this.state.focusId);
      if (element !== null && element instanceof HTMLInputElement) {
        this.focusInputWithoutScrolling(element);
        const focusPosition = this.state.focusPosition === undefined
          ? element.value.length
          : Math.min(this.state.focusPosition, element.value.length);
        element.setSelectionRange(focusPosition, focusPosition);
        this.scrollInputIntoView(element);
      }

      this.setState({focusId:undefined, focusPosition:undefined}); // reset focus after focusing
    }
    

    if (this.state.title !== prevState.title ||
        this.state.icon !== prevState.icon ||
        this.state.avatarId !== prevState.avatarId ||
        this.state.visibleFor !== prevState.visibleFor ||
        ((!this.props.isAccountNote) && this.state.listItems !== prevState.listItems) ||
        ((this.props.isAccountNote) && this.state.accountPassword !== prevState.accountPassword) ||
        ((this.props.isAccountNote) && this.state.accountUsername !== prevState.accountUsername) ||
        this.state.desc !== prevState.desc) {
      
        if (this.timer) {clearTimeout(this.timer);}

        if (this.state.undoPressed) {
          this.setState({undoPressed:false});
        } else {
          this.timer = setTimeout(() => {this.checkIcon(); this.saveNote();}, 2000);
        }
    }
  }

  public checkIcon = () => {
    if (this.props.editNoteId === undefined || this.props.editNoteId === 0) {
      return;
    }
    if (this.state.icon !== undefined && this.state.icon.length > 1) {
      return; // icon already set
    }
    if (this.state.avatarId !== undefined && this.state.avatarId > 0) {
      return; // avatar already set
    }
    if (this.props.aiIconTasks.find((task) => task.refObject === this.props.editNoteId 
      && task.taskType === AI_TASK_TYPE.NOTE_ICON && task.status === AI_RESULT.IN_PROGRESS)) {
      return; // icon generation already in progress
    }
    if (this.props.aiIconTasks.find((task) => task.refObject === this.props.editNoteId 
      && task.taskType === AI_TASK_TYPE.NOTE_ICON && task.status === AI_RESULT.FAIL)) {
      return; // icon generation failed
    }
    if (this.state.listItems.length < 3 && this.state.desc.length < 20) {
      return; // not enough data to generate icon
    }
    if (this.state.title.length < 5) {
      return; // not enough data to generate icon
    }
    this.requestIcon();
  }

  public saveNote = (publish?:boolean) => {
    if (this.timer) {clearTimeout(this.timer);}



    const sharedNote:ISharedNote = {
      noteId: (this.props.editNoteId && this.props.editNoteId !== 0)?this.props.editNoteId:-10,
      serviceName: this.state.title,
      icon: this.state.icon,
      avatarId: this.state.avatarId,
      visibleFor: this.state.visibleFor,
      seenBy: [],
      listItems: this.state.listItems.filter((item) => item.deleted !== true).map((li) => ({val: li.val, format: li.format})),
      text: (this.state.desc && this.state.desc.length > 0)?this.state.desc:undefined,
      accountName: this.props.isAccountNote?this.state.accountUsername:undefined,
      accountPassword: this.props.isAccountNote?this.state.accountPassword:undefined,
    };

    if ((sharedNote.serviceName === undefined || sharedNote.serviceName.length === 0) && sharedNote.noteId > 0) {
      return;
    } else if ((!this.props.isAccountNote) 
        && (sharedNote.listItems === undefined || sharedNote.listItems.length === 0) 
        && (sharedNote.text === undefined || sharedNote.text.length === 0)) {
      return;
    } else if ((this.props.isAccountNote) 
        && (sharedNote.accountName === undefined || sharedNote.accountName.length === 0) 
        && (sharedNote.accountPassword === undefined || sharedNote.accountPassword.length === 0)) {
      return;
    } else if (sharedNote.visibleFor === undefined || sharedNote.visibleFor.length === 0) {
      return;
    }

    if (this.props.editNoteId && this.props.editNoteId !== 0) {
      let currentNote:ISharedNote|undefined;

      if (this.props.editNoteId !== undefined && this.props.editNoteId > 0) {
        currentNote = this.props.sharedNotes.find((n) => n.noteId === this.props.editNoteId);
      } else if (this.props.editNoteId !== undefined && this.props.editNoteId < 0) {
        currentNote = this.props.localNotes.find((n) => n.noteId === this.props.editNoteId);
      }
  
      if (currentNote === undefined) {
        return;
      } else if (this.props.isAccountNote &&
          (publish === undefined || publish === false) &&
          (currentNote.text?currentNote.text:"") === (sharedNote.text?sharedNote.text:"") &&
          currentNote.accountName === sharedNote.accountName &&
          currentNote.serviceName === sharedNote.serviceName &&
          currentNote.icon === sharedNote.icon &&
          currentNote.avatarId === sharedNote.avatarId &&
          currentNote.accountPassword === sharedNote.accountPassword &&
          JSON.stringify(currentNote.visibleFor.sort()) === JSON.stringify(sharedNote.visibleFor.sort()) ) {
        return; // no changes
      } else if ((!this.props.isAccountNote) &&
          (publish === undefined || publish === false) &&
          (currentNote.text?currentNote.text:"") === (sharedNote.text?sharedNote.text:"") &&
          currentNote.serviceName === sharedNote.serviceName &&
          currentNote.icon === sharedNote.icon &&
          currentNote.avatarId === sharedNote.avatarId &&
          JSON.stringify(currentNote.visibleFor.sort()) === JSON.stringify(sharedNote.visibleFor.sort()) &&
          ((currentNote.listItems && sharedNote.listItems) && areEqualUnordered(currentNote.listItems, sharedNote.listItems))) {
        return; // no changes
      }
      
      if (sharedNote.noteId < 0) {
        if (publish) {
          this.props.localDel(sharedNote.noteId);
          this.props.updateSharedNote(sharedNote);
          this.setState({history:[]});
        } else {
          const latestCopy:ISharedNote = JSON.parse(JSON.stringify(sharedNote));
          const history:ISharedNote[] = this.state.history.slice(0, 10)
          history.unshift(latestCopy);
          this.setState({history});
          this.props.localSave(sharedNote);
        }
      } else {
        const latestCopy:ISharedNote = JSON.parse(JSON.stringify(sharedNote));
        const history:ISharedNote[] = this.state.history.slice(0, 10);
        history.unshift(latestCopy);

        this.setState({lastSeenVersionTimestamp: -1, history});
        this.props.updateSharedNote(sharedNote);
      }
    }
  }

  public componentDidMount(): void {
    this.setState(this.loadData(this.props))
    const vv = (window as any).visualViewport;
    if (vv) {
      vv.addEventListener('resize', this.handleViewportResize);
      vv.addEventListener('scroll', this.handleViewportResize);
    }
  }

  public loadData(props:IProps):IState {
    const newState:IState = {
      title: tn.lang.labelTitle,
      icon:undefined,
      avatarId:undefined,
      visibleFor:[],
      desc:"",
      listItems:[],
      showVisibleForSelect: false,
      showIconSelect:false,
      showIconList:false,
      showMenu:false,
      hasDesc: false,
      bounceTopItem: false,
      internalUploadId: undefined,
      history: [],
      undoPressed: false,
      accountPassword: "",
      accountUsername: "",
      lastSeenVersionTimestamp:0,
    }

    const note:ISharedNote|undefined = props.editNoteId
    ?props.editNoteId > 0
      ?props.sharedNotes.find((n) => n.noteId === this.props.editNoteId)
      :props.localNotes.find((n) => n.noteId === this.props.editNoteId)
    :undefined;

    if (note) {
      if (note.text !== undefined && note.text.length > 0) {
        newState.hasDesc = true;
      }
      newState.desc = note.text?note.text:"";
      newState.listItems = note.listItems && note.listItems.length>0
        ?this.ensureAddPossible(this.ensureKeyed([...note.listItems]))
        :[];
      newState.avatarId = note.avatarId;
      newState.icon = note.icon;
      newState.title = note.serviceName;
      newState.visibleFor = note.visibleFor;
      newState.history = [JSON.parse(JSON.stringify(note))]; // initial history with current note state
      newState.accountUsername = note.accountName? note.accountName:"";
      newState.accountPassword = note.accountPassword?note.accountPassword:"";
      newState.lastSeenVersionTimestamp = note.lastUpdate?note.lastUpdate:-1

      setTimeout(() => this.setState({ bounceTopItem: true }), 300);
    }

    return newState;
  }

  public render() {
    const {classes, family} = this.props;
    const {icon, avatarId, listItems} = this.state;

    const stickerIcons: JSX.Element[] = [];

    for (const fileName of stickers) {
      stickerIcons.push(this.getIcon(fileName));
    }
    if (this.props.isAccountNote) {
      for (const fileName of services) {
        stickerIcons.push(this.getIcon(fileName));
      }
    }

    let iconImage:JSX.Element = <div/>;
    const iconGeneration = this.props.aiIconTasks.find((task) => task.refObject === this.props.editNoteId);

    if (icon  && icon.length > 1) {
      if (icon.startsWith("http")) {
        iconImage = <div className={classes.icon} ref={this.iconRef} onClick={() => this.setState({showIconSelect:true})}>
          <img src={icon} className={classes.imageIcon} />
        </div>
      } else {
        iconImage = <div className={classes.icon} ref={this.iconRef} onClick={() => this.setState({showIconSelect:true})}>
          <img
            src={"logos/" + icon}
            className={classes.imageIcon}
            style={{backgroundColor: styleColors.softYellow}}/>
          </div>
      }
    } else if (avatarId && avatarId > 0) {
      const avatarMember = family.find((mem) => mem.id === avatarId);
      if (avatarMember !== undefined) {
        iconImage = <div className={classes.icon} ref={this.iconRef} onClick={() => this.setState({showIconSelect:true})}>
          <ImgAvatar
            key={avatarMember.id}
            altText={avatarMember.firstName}
            color={avatarMember.color}
            imgName={avatarMember.avatar}
            imgUrl={avatarMember.imageAvatar?avatarMember.avatarURL:undefined}
            style={{
              width: '100%',
              height: '100%',
            }}
          />
        </div>;
      }
    } else  if (this.state.internalUploadId !== undefined
      || (iconGeneration && iconGeneration.status === AI_RESULT.IN_PROGRESS)) {
      iconImage = <div className={classes.icon} ref={this.iconRef} onClick={() => this.setState({showIconSelect:false})} style={{border:'0px solid #fff'}}>
          <div className={classes.icon + " "+classes.skeletonBorder + " "+classes.skeletonBorderRound} style={{border:'0px solid #fff'}} />
        </div>;
    } else {
      iconImage = <div className={classes.icon} ref={this.iconRef} onClick={() => this.setState({showIconSelect:true})} />;
    }

    const lessThan3Item = this.state.listItems.filter((l) => l.deleted !== true).length < 4;

    const visibleFor:JSX.Element[] = this.props.family.filter((mem) => this.state.visibleFor.includes(mem.id)).map((mem) => 
      tn.avatarMem(mem, {width:'16px', height:'16px'}));

    let bottomBar:JSX.Element|undefined;

    const aiTask = this.props.aiTasks.find((task) => task.refObject !== undefined 
      && task.refObject === this.props.editNoteId && task.taskType === AI_TASK_TYPE.NOTE);

    if (aiTask && aiTask.status === AI_RESULT.IN_PROGRESS) {
      bottomBar = <div className={classes.sharedNoteBottomBar} >
        <div className={classes.workingNeonPill}>{tn.lang.working}</div>
      </div>;
    } else if (this.props.editNoteId && this.props.editNoteId < 0) {
      const generatingIcon = (this.props.aiIconTasks.find((task) => task.refObject === this.props.editNoteId 
              && task.startTime !== undefined && task.startTime > (Date.now()-15000)
              && task.status === AI_RESULT.IN_PROGRESS) !== undefined)
      bottomBar = <div className={classes.sharedNoteBottomBar}>
        <Button color='primary' variant='contained' className={classes.buttonContained}
          disabled={this.state.title.length < 2 || generatingIcon || visibleFor.length < 1
            || ((!this.props.isAccountNote) && this.state.listItems.length < 2 && this.state.desc.length < 2)
            || ((this.props.isAccountNote) && this.state.accountPassword.length < 2 && this.state.accountUsername.length < 2)}
          onClick={() => {this.saveNote(true); this.props.close();}}>
          {generatingIcon?tn.lang.sharedNoteGeneratingIcon:tn.lang.save}
        </Button>
      </div>;
    } else {
      bottomBar = <div className={classes.sharedNoteBottomBar} 
        style={{maxHeight:0, padding:0, pointerEvents:'none'}}>
        <Button variant='contained' className={classes.buttonContained} disabled={true}>
          {tn.lang.working}
        </Button>
      </div>; 
    }

    return (<>
      <div style={{    position: 'absolute', top:0, left: 0, zIndex: 1, width: '100%', transition:'all 0.3s',
        minHeight: '100%', maxHeight:'100%', overflow:'hidden', opacity:(this.props.editNoteId?1:0), backgroundColor:this.props.backgroundColor,
        pointerEvents:(this.props.editNoteId?undefined:'none'),}}
        onClick={() => {this.saveNote(); this.props.close();}} ref={this.hideRef} />

      <div className={classes.sharedNotePane} ref={this.paneRef} >
        <div className={classes.sharedNotePaneTop} 
          onTouchStart={(e) => this.paneMoveStart(e)} onTouchMove={(e) => this.paneMove(e)} onTouchEnd={(e) => this.paneMoveEnd(e)}>
          <div className={classes.sharedNotePaneTopContent}/>
        </div>
        <div  className={classes.sharedNoteList} ref={this.scrollListRef} style={{userSelect: 'none'}} >
          <div>
            <div className={classes.shareNoteListItem} >
              <div className={classes.shareNoteListItemIcon}>
                {iconImage}
              </div>
              <div className={classes.shareNoteListItemBody} style={{flexDirection:'row'}}>
                  <div style={{flex:1, alignSelf: 'center', display: 'flex', flexDirection: 'column'}}>
                    <input
                      style={{margin:'1px 1px 6px', flex:1, 
                        border:((this.state.title.length === 0)?('1px solid '+primaryColor):'1px solid #00000000'),}}
                      // ref={this.titleRef}
                      id="note-title"
                      type="text"
                      value={this.state.title}
                      spellCheck={true}
                      maxLength={45}
                      onChange={(event) => {this.setState({title:event.target.value})}}
                      className={classes.greyInput}
                      placeholder={this.props.isAccountNote?tn.lang.service:tn.lang.labelTitle}/>
                    <div style={{display: 'flex', gap: '2px',marginLeft:'2px'}} ref={this.visibleForRef} onClick={() => 
                      this.setState({showVisibleForSelect:true})}>
                      <div style={this.state.visibleFor.length === 0?{color:primaryColor}:{}}>{tn.lang.sharedNoteVisible}</div>
                      {visibleFor}
                    </div>
                    <Popover 
                      disableScrollLock={true}
                      anchorEl={this.visibleForRef.current}
                      onClose={() => this.setState({showVisibleForSelect:false})}
                      open={(this.state.showVisibleForSelect === true)}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                      }}
                    >
                      <div style={{padding:'16px', display:'flex', flexDirection:'column', gap:'16px'}}>
                      {family
                        .filter((mem) => (mem.role === FamilyMemberType.PARENT || mem.role === FamilyMemberType.CHILD 
                          || mem.role === FamilyMemberType.VIEWER))
                        .map((mem) =>
                        <div key={mem.id} onClick={() => this.setState((prevState: IState) => 
                          ({...prevState, visibleFor: prevState.visibleFor.includes(mem.id)
                            ? prevState.visibleFor.filter((id) => id !== mem.id)
                            : [...prevState.visibleFor, mem.id]}))}>
                          <div style={{display:'flex', flexDirection:'row', alignItems:'center', gap:'8px'}}>
                            <ImgAvatar key={mem.id} color={mem.color} altText={mem.firstName} imgName={mem.avatar} 
                              imgUrl={mem.imageAvatar ? mem.avatarURL : undefined} grayed={!this.state.visibleFor.includes(mem.id)}/>
                            <div style={{fontSize:'16px'}}>{mem.firstName}</div>
                          </div>
                        </div>
                      )}
                      </div>
                    </Popover>
                  </div>

                  <IconButton onClick={() => this.setState({showMenu:!this.state.showMenu})} 
                    style={{alignItems: 'flex-start', marginRight:'8px', marginTop: '6px'}} ref={this.menuRef}>
                    <DotsIcon  style={{ opacity:'0.84'}}/>
                  </IconButton>

                  <Menu
                    anchorEl={this.menuRef.current}
                    open={this.state.showMenu}
                    anchorReference="anchorEl"
                    onClose={() => this.setState({showMenu:false})}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                  >
                    {(!this.props.isAccountNote) && <MenuItem onClick={() => 
                      {this.sortList(this.props.editNoteId); this.setState({showMenu:false});}}>
                      <ListItemIcon>
                        <span style={{paddingLeft:'4px'}}>Ai</span>
                      </ListItemIcon>
                      <ListItemText>
                        {tn.lang.sort}
                      </ListItemText>
                    </MenuItem>}
                    <MenuItem onClick={() => {this.setState({hasDesc: !this.state.hasDesc}); this.setState({showMenu:false});}}>
                      <ListItemIcon>
                        <DescIcon />
                      </ListItemIcon>
                      <ListItemText>
                        {tn.lang.sharedNoteAddText}
                      </ListItemText>
                    </MenuItem>
                    <MenuItem onClick={() => {this.delete(); this.setState({showMenu:false});}}>
                      <ListItemIcon>
                        <DeleteIcon />
                      </ListItemIcon>
                      <ListItemText>
                        {tn.lang.erase}
                      </ListItemText>
                    </MenuItem>
                    <MenuItem onClick={() => {this.undo();}} disabled={this.state.history.length === 1}>
                      <ListItemIcon>
                        <UndoIcon />
                      </ListItemIcon>
                      <ListItemText>
                        {tn.lang.undo}
                      </ListItemText>
                    </MenuItem>
                    {(!this.props.isAccountNote) && <MenuItem onClick={() => {
                      this.copyListToClipboard();
                      this.setState({showMenu:false});
                    }}>
                      <ListItemIcon>
                        <CopyIcon />
                      </ListItemIcon>
                      <ListItemText>
                        {tn.lang.copyToClipboard}
                      </ListItemText>
                    </MenuItem>}
                    <MenuItem onClick={() => {this.saveNote(); this.props.close(); this.setState({showMenu:false});}}>
                      <ListItemIcon>
                        <CloseIcon />
                      </ListItemIcon>
                      <ListItemText>
                        {tn.lang.close}
                      </ListItemText>
                    </MenuItem>
                  </Menu>
                  <Menu
                    anchorEl={this.iconRef.current}
                    open={this.state.showIconSelect}
                    anchorReference="anchorEl"
                    onClose={() => this.setState({showIconSelect:false})}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                  >
                    {family
                      .filter((mem) => (mem.role === FamilyMemberType.PARENT || mem.role === FamilyMemberType.CHILD 
                        || mem.role === FamilyMemberType.VIEWER))
                      .map((mem) =>
                        <MenuItem key={mem.id} onClick={() => this.setState({avatarId: mem.id, icon:undefined, showIconSelect:false})}>
                          <ListItemIcon>
                            <ImgAvatar key={mem.id} color={mem.color} altText={mem.firstName} imgName={mem.avatar} 
                              imgUrl={mem.imageAvatar ? mem.avatarURL : undefined} grayed={!this.state.visibleFor.includes(mem.id)}/>
                          </ListItemIcon>
                          <ListItemText>
                            {mem.firstName}
                          </ListItemText>
                        </MenuItem>
                    )}
                    {(!this.props.isAccountNote) && 
                      <MenuItem onClick={() => {this.requestIcon(); 
                        this.setState({showIconSelect:false, icon:undefined, avatarId:undefined})}} 
                        disabled={lessThan3Item || (iconGeneration && iconGeneration.status === AI_RESULT.IN_PROGRESS)}>
                        <ListItemText >
                          <span style={{display:'flex', flexDirection:'column'}}>
                            <span>{tn.lang.generate}</span>
                            {lessThan3Item && <span style={{fontSize: '8px', lineHeight: '8px'}}>lista minst 3 saker</span>}
                          </span>
                        </ListItemText>
                      </MenuItem>
                    }
                    <MenuItem onClick={() => this.setState({showIconList:!this.state.showIconList})} >
                      <ListItemText>
                        {tn.lang.libraryLabel}
                      </ListItemText>
                      <ListItemSecondaryAction ref={this.iconSubRef}>
                        <ArrowRightIcon />
                      </ListItemSecondaryAction>
                    </MenuItem>
                    <MenuItem>
                      <label htmlFor="add-file-noteIcon" style={{display:'flex', width:'100%', cursor:'pointer'}}>
                        <input type="file" multiple={false} style={{opacity: 0, position: 'absolute', width:'1px', height:'1px'}}
                          id={"add-file-noteIcon"} onChange={this.loadLocalIconFile} accept="capture=camera,image/*"/>
                        <ListItemText>
                          {tn.lang.uploadImage}
                        </ListItemText>
                      </label>
                    </MenuItem>

                  </Menu>
                  <Popover 
                    disableScrollLock={true}
                    anchorEl={this.iconSubRef.current}
                    onClose={() => this.setState({showIconList:false})}
                    open={(this.state.showIconList === true)}
                    anchorOrigin={{
                      vertical: 'center',
                      horizontal: 'center',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'center',
                    }}
                  >
                    <div style={{padding:'16px', display:'flex', flexDirection:'row', gap:'8px', flexFlow:'wrap'}}>
                      {stickerIcons}
                    </div>
                  </Popover>
              </div>
            </div>
            <div style={{display: 'flex', flexDirection: 'column'}} id={"notesHolder-"+this.props.editNoteId}>
              <Autosize onChange={(e) => this.setState({desc:e.target.value})} value={this.state.desc} handleKeyPress={(evt) => {return}}
                style={{margin: this.state.hasDesc?'8px 21px':'0px 21px', maxWidth:'calc(100% - 42px)', boxSizing: 'border-box', 
                maxHeight:this.state.hasDesc?'2000px':'0px', transition:'all 0.3s', opacity: this.state.hasDesc?1:0, 
                pointerEvents:this.state.hasDesc?undefined:'none'}}/>
              {listItems.map((item, index) => this.renderNoteItem(item, index))}
              {this.props.isAccountNote && <div style={{display:'flex', flexDirection:'column', margin:'21px', gap:'20px'}}>
                <div style={{display:'flex', flexDirection:'row', alignItems:'center', gap:'8px'}}>
                  <div style={{flex:1, display: 'flex', flexDirection: 'column'}}>
                    <div style={{fontSize: '12px', color: styleColors.greyMedium2}}>{tn.lang.labelUsername}</div>
                    <input
                      style={{margin:'1px 1px 6px', flex:1}}
                      // ref={this.titleRef}
                      id="note-username"
                      type="text"
                      value={this.state.accountUsername}
                      maxLength={29}
                      onChange={(event) => {this.setState({accountUsername:event.target.value})}}
                      className={classes.greyInput}
                      placeholder={tn.lang.labelUsername}/>
                  </div>
                  <IconButton onClick={() => this.copyToClipBoard(this.state.accountUsername)}>
                    <CopyIcon style={{color:styleColors.blackAlpha45}}/>
                  </IconButton>
                </div>

                <div style={{display:'flex', flexDirection:'row', alignItems:'center', gap:'8px'}}>
                  <div style={{flex:1, display: 'flex', flexDirection: 'column'}}>
                    <div style={{fontSize: '12px', color: styleColors.greyMedium2}}>{tn.lang.labelPassword}</div>
                    <input
                      style={{margin:'1px 1px 6px', flex:1}}
                      // ref={this.titleRef}
                      id="note-password"
                      type="text"
                      value={this.state.accountPassword}
                      maxLength={29}
                      onChange={(event) => {this.setState({accountPassword:event.target.value})}}
                      className={classes.greyInput}
                      placeholder={tn.lang.labelPassword}/>
                  </div>
                  <IconButton onClick={() => this.copyToClipBoard(this.state.accountPassword)}>
                    <CopyIcon style={{color:styleColors.blackAlpha45}}/>
                  </IconButton>
                </div>
              </div>}           
            </div>
            {bottomBar}
          </div>
        </div>
      </div>
      </>);
  }

  // On iOS (WKWebView, no keyboard plugin) the soft keyboard overlaps the
  // bottom of the absolutely-positioned pane without resizing it, so the rows
  // being edited end up hidden behind the keyboard and can't be scrolled to.
  // Use visualViewport to add matching bottom padding (extra scroll headroom)
  // and bring the focused row into view. Purely additive — never blocks scroll.
  private handleViewportResize = () => {
    const vv = (window as any).visualViewport;
    if (!this.scrollListRef.current || !vv) {
      return;
    }
    const keyboardOverlap = Math.max(0, window.innerHeight - (vv.height + vv.offsetTop));
    this.scrollListRef.current.style.paddingBottom =
      `calc(${200 + keyboardOverlap}px + env(safe-area-inset-bottom, 0px))`;
    if (keyboardOverlap > 0) {
      const active = document.activeElement;
      if (active instanceof HTMLInputElement) {
        this.scrollInputIntoView(active);
      }
    }
  };

  // Focusing a newly-created row does not resize an already-open keyboard, so
  // visualViewport emits no event. Scroll after the row has rendered to keep it
  // above the overlaid action and navigation bars on every viewport height.
  private scrollInputIntoView = (input: HTMLInputElement) => {
    setTimeout(() => {
      const container = this.scrollListRef.current;
      if (!container || !container.contains(input)) {
        return;
      }

      const inputRect = input.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();
      const vv = (window as any).visualViewport;
      const viewportBottom = vv ? vv.offsetTop + vv.height : window.innerHeight;
      const visibleTop = containerRect.top + 16;
      const visibleBottom = Math.min(containerRect.bottom, viewportBottom) - 96;

      if (inputRect.top < visibleTop) {
        container.scrollTop -= visibleTop - inputRect.top;
      } else if (inputRect.bottom > visibleBottom) {
        container.scrollTop += inputRect.bottom - visibleBottom;
      }
    }, 50);
  };

  private focusInputWithoutScrolling = (input: HTMLInputElement) => {
    const container = this.scrollListRef.current;
    const scrollTop = container ? container.scrollTop : undefined;
    const scrollLeft = container ? container.scrollLeft : undefined;

    try {
      input.focus({preventScroll: true});
    } catch (error) {
      input.focus();
    }

    if (container && scrollTop !== undefined && scrollLeft !== undefined) {
      container.scrollTop = scrollTop;
      container.scrollLeft = scrollLeft;
    }
  };

  private sortList = (noteId:number|undefined) => {

    if (noteId === undefined) {return;}

    const note:ISharedNote|undefined = noteId > 0
        ?this.props.sharedNotes.find((n) => n.noteId === noteId)
        :this.props.localNotes.find((n) => n.noteId === noteId);

    let aiNote:IAiNote = {id: noteId,title: "Title",text: "",list: [],};

    if (note !== undefined) {
        aiNote = {
            id: note.noteId,
            title: note.serviceName,
            text: note.text,
            list: note.listItems?.filter((item) => item.deleted !== true)
                .map((item) => ({title:item.val, header:item.format === 2})) || [],
        };
    }

    const search:IAiTask = {
        promptOne:tn.lang.sharedNoteExampleEditPromptPrompt1,
        promptTwo:"",
        promptThree:JSON.stringify(aiNote),
        refObject:noteId,
        taskType:AI_TASK_TYPE.NOTE,
    }

    this.props.aiTask(search);
  }

  private requestIcon = () => {

    if (this.props.editNoteId !== undefined && this.props.editNoteId !== 0 
      && (this.state.listItems.length > 2 || this.state.desc.length > 2)
      && this.state.title.length > 2) {

      const aiNote:IAiNote = {
          id: this.props.editNoteId,
          title: this.state.title,
          text: this.state.desc,
          list: this.state.listItems?.filter((item) => item.deleted !== true)
              .map((item) => ({title:item.val, header:item.format === 2})) || [],
      };

      const iconRequest:IAiTask = {
          promptOne:JSON.stringify(aiNote),
          refObject:this.props.editNoteId,
          taskType:AI_TASK_TYPE.NOTE_ICON,
      }

      this.props.aiTask(iconRequest)
    }
  }

  private loadLocalIconFile = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const input = event.currentTarget;

    try {
      const { files } = input;
      if (files && files.length > 0) {
        const f:File|null = files.item(0);
        if (f !== null) {
          const mime = (f.type || mimeFromFilename(f.name)).toLowerCase();
          const imageMime = mime.includes("image") ? mime : "image/jpeg";
          const data = await f.arrayBuffer();
          const blob = new Blob([data], { type: imageMime });
          const previewUrl = URL.createObjectURL(blob);

          let fileName = f.name;
          if (!fileName || fileName.trim().length === 0 || fileName.indexOf(".") === -1) {
            const ext = imageMime.includes("png") ? "png" : (imageMime.includes("webp") ? "webp" : "jpg");
            fileName = "note-icon."+ext;
          }
          const fileUpload = handleImageUpload(blob, fileName, previewUrl, this.props.uploadFile);
          this.setState({internalUploadId:fileUpload.internalId, showIconSelect:false, showIconList:false});
        }
      }
    } catch (error) {
      console.error("Failed to read selected note icon file", error);
    } finally {
      // allow selecting the same file again
      try {
        input.value = "";
      } catch (_) {
        // ignore
      }
    }
  }

  private delete() {
    if (this.props.editNoteId === undefined || this.props.editNoteId === 0) {
      return;
    }
    if (this.props.editNoteId < 0) {
      this.props.localDel(this.props.editNoteId);
    } else {
      this.props.deleteSharedNote(this.props.editNoteId);
    }

    this.props.close();
  }
  
  private splitRow(line:number, input: HTMLInputElement) {
    if (this.state.listItems === undefined || this.state.listItems.length <= line) {
      return;
    }

    const item = this.state.listItems[line];
    const currentValue = input.value;
    const data = this.state.listItems.slice();
    if (currentValue.trim() === "") {
      data[line] = {...item, val: ""};
      this.setState({listItems: this.ensureAddPossible(data)});
      return;
    }

    const selectionStart = input.selectionStart === null ? currentValue.length : input.selectionStart;
    const selectionEnd = input.selectionEnd === null ? selectionStart : input.selectionEnd;
    const beforeCursor = currentValue.substring(0, selectionStart).trim();
    const afterCursor = currentValue.substring(selectionEnd).trim();
    data[line] = {...item, val: beforeCursor};

    const nextItem = data[line + 1];
    if (afterCursor === "" && nextItem !== undefined && nextItem.deleted !== true
        && (nextItem.format === undefined || nextItem.format === 0)
        && nextItem.val.trim() === "" && nextItem.key !== undefined) {
      data[line + 1] = {...nextItem, val: ""};
      this.setState({listItems: this.ensureAddPossible(data), focusId: nextItem.key, focusPosition: 0});
      return;
    }

    const newKey = "key-"+this.keyCounter;
    this.keyCounter++;
    data.splice(line + 1, 0, {val: afterCursor, format: 0, key: newKey});
    this.setState({listItems: this.ensureAddPossible(data), focusId: newKey, focusPosition: 0});
  }

  private handleListEnter(line:number, input: HTMLInputElement) {
    const now = Date.now();

    if (now - this.lastEnterSplitTime < 350) {
      return;
    }

    this.lastEnterSplitTime = now;
    this.splitRow(line, input);
  }

  private isEnterEvent(event: React.KeyboardEvent<HTMLInputElement>):boolean {
    const nativeEvent = event.nativeEvent as any;
    return event.key === "Enter"
      || event.keyCode === 13
      || event.which === 13
      || nativeEvent.key === "Enter"
      || nativeEvent.keyCode === 13
      || nativeEvent.which === 13
      || nativeEvent.code === "Enter";
  }

  private handleListKeyDown(line:number, event: React.KeyboardEvent<HTMLInputElement>) {
    if (this.isEnterEvent(event) && !(event.nativeEvent as any).isComposing) {
      event.preventDefault();
      this.handleListEnter(line, event.currentTarget);
    }
  }

  private handleListKeyPress(line:number, event: React.KeyboardEvent<HTMLInputElement>) {
    if (this.isEnterEvent(event) && !(event.nativeEvent as any).isComposing) {
      event.preventDefault();
      this.handleListEnter(line, event.currentTarget);
    }
  }

  private handleListKeyUp(line:number, event: React.KeyboardEvent<HTMLInputElement>) {
    if (this.isEnterEvent(event) && !(event.nativeEvent as any).isComposing) {
      event.preventDefault();
      this.handleListEnter(line, event.currentTarget);
      return;
    }

    this.keyPress(line, event.key);
  }

  private handleListBeforeInput(line:number, event: React.FormEvent<HTMLInputElement>) {
    const nativeEvent = event.nativeEvent as any;
    if (nativeEvent.inputType === "insertLineBreak" || nativeEvent.inputType === "insertParagraph") {
      event.preventDefault();
      this.handleListEnter(line, event.currentTarget);
    }
  }

  private pasteRows(line:number, event: React.ClipboardEvent<HTMLInputElement>) {
    const pastedText = this.getClipboardText(event, 'text/plain') || this.getClipboardText(event, 'text');
    const pastedHtml = this.getClipboardText(event, 'text/html');
    if (this.isOversizedPaste(pastedText, pastedHtml)) {
      event.preventDefault();
      return;
    }

    const pastedRows = parsePastedListItems(pastedText, pastedHtml);
    if (pastedRows.length < 2 || this.state.listItems.length <= line) {
      return;
    }

    event.preventDefault();

    const input = event.currentTarget;
    const item = this.state.listItems[line];
    const currentValue = input.value;
    const selectionStart = input.selectionStart === null ? currentValue.length : input.selectionStart;
    const selectionEnd = input.selectionEnd === null ? selectionStart : input.selectionEnd;
    const beforeSelection = currentValue.substring(0, selectionStart);
    const afterSelection = currentValue.substring(selectionEnd);
    const values = pastedRows.map((row, index) => {
      const prefix = index === 0 ? beforeSelection : "";
      const suffix = index === pastedRows.length - 1 ? afterSelection : "";
      const format = (prefix.length === 0 && suffix.length === 0) ? row.format : undefined;
      return {val:(prefix + row.val + suffix).substring(0, 512), format};
    });

    const data = this.state.listItems.slice();
    data[line] = {...item, val: values[0].val, format: values[0].format === 2 ? 2 : item.format};

    let focusKey = item.key;
    for (let index = 1; index < values.length; index++) {
      focusKey = "key-"+this.keyCounter;
      this.keyCounter++;
      data.splice(line + index, 0, {val: values[index].val, format: values[index].format === 2 ? 2 : 0, key: focusKey});
    }

    this.setState({
      listItems: this.ensureAddPossible(data),
      focusId: focusKey,
      focusPosition: Math.min(pastedRows[pastedRows.length - 1].val.length, values[values.length - 1].val.length),
    });
  }

  private getClipboardText(event: React.ClipboardEvent<HTMLInputElement>, type:string):string {
    if (!event.clipboardData) {
      return "";
    }

    try {
      return event.clipboardData.getData(type) || "";
    } catch (error) {
      return "";
    }
  }

  private isOversizedPaste(plainText:string, htmlText:string):boolean {
    const textToMeasure = plainText.length > 0 ? plainText : htmlText;
    return textToMeasure.length > MAX_PASTED_LIST_CHARS;
  }

  private keyPress(line:number, key:string) {
    if (this.state.listItems === undefined || this.state.listItems.length <= line) {
      return;
    }
    if (key === "Backspace" && this.state.listItems[line].val === "" && this.state.listItems.length > 1 ) {

      // TODO special case when last item

      let nextFocus:string|undefined;

      for (let i = this.state.listItems.length-1; i >= 0; i--) {
        if (this.state.listItems[i].deleted !== true && i !== line) {
          if (this.state.listItems[i].format === undefined || this.state.listItems[i].format === 0){
            nextFocus = this.state.listItems[i].key;
            if (i < line) {
              break;
            }
          }
        }
      }

      this.deleteRow(line);

      if (nextFocus !== undefined) {
        const element = document.getElementById(nextFocus);
        if (element !== null && element instanceof HTMLInputElement) {
          element.focus();
          element.selectionStart = element.value.length;
        }
      }
    } else if (key === "ArrowUp" && line > 0) {
      let focusNext:string|undefined;
      for (let i = line - 1; i >= 0; i--) {
        if (this.state.listItems[i].deleted !== true && this.state.listItems[i].format !== 1) {
          focusNext = this.state.listItems[i].key;
          break;
        }
      }
      if (focusNext) {
        const element = document.getElementById(focusNext);
        if (element !== null && element instanceof HTMLInputElement) {
          element.focus();
          element.selectionStart = element.value.length;
        }
      }
      
    } else if (key === "ArrowDown" && (line + 1) < this.state.listItems.length) {
      let focusNext:string|undefined;
      for (let i = line + 1; i < this.state.listItems.length; i++) {
        if (this.state.listItems[i].deleted !== true && this.state.listItems[i].format !== 1) {
          focusNext = this.state.listItems[i].key;
          break;
        }
      }
      if (focusNext) {
        const element = document.getElementById(focusNext);
        if (element !== null && element instanceof HTMLInputElement) {
          element.focus();
          element.selectionStart = element.value.length;
        }
      }
    }
  } 

  private ensureKeyed(listItems:IListItem[]):IListItem[] {
    for (const listItem of listItems) {
      if (listItem.key === undefined) {
        listItem.key = "key-"+this.keyCounter; // add key if missing
        this.keyCounter++;
      }
    }
    return listItems;
  }

  private ensureAddPossible(listItems:IListItem[]):IListItem[] {
    
    let lastItem:IListItem|undefined ;
    for (let i = listItems.length-1; i >= 0; i--) {
      if (listItems[i].deleted !== true && listItems[i].format !== 1) {
        lastItem = listItems[i];
        break;
      }
    }

    if (lastItem === undefined || lastItem.val !== "") {
      // add empty row
      listItems.push({val: "", format: 0, key: "key-"+this.keyCounter});
      this.keyCounter++;
      return listItems;
    }

    return listItems
  }

  private crossRow(index:number) {
    if (this.state.listItems === undefined || this.state.listItems.length <= index) {
      return;
    }

    const wrapper = document.getElementById(`notesHolder-${this.props.editNoteId}`);
    if (wrapper) {
      // wrapper.children is an HTMLCollection; convert to Array so we can use forEach
      Array.from(wrapper.children).forEach(child => {
        // for each child element, reset scrollLeft
        child.scrollLeft = 0;
      });
    }

    this.setState((state) => {
      const data = this.state.listItems.slice();
      let format = this.state.listItems[index].format
      if (format === undefined || format === 0) {
        format = 1; // Crossed
      } else {
        format = 0; // Uncrossed
      }
      data[index] = {val: this.state.listItems[index].val, format, key:this.state.listItems[index].key};

      return {...state, listItems: this.ensureAddPossible(data)}
    });

  }

  private deleteRow(index:number) {
    if (this.state.listItems === undefined || this.state.listItems.length <= index) {
      return;
    }

    const wrapper = document.getElementById(`notesHolder-${this.props.editNoteId}`);
    if (wrapper) {
      // wrapper.children is an HTMLCollection; convert to Array so we can use forEach
      Array.from(wrapper.children).forEach(child => {
        // for each child element, reset scrollLeft
        child.scrollLeft = 0;
      });
    }

    this.setState((state) => {
      const data = this.state.listItems.slice();
      data[index] = {val: this.state.listItems[index].val, format: this.state.listItems[index].format, 
        key: this.state.listItems[index].key, deleted:true};
      return {...state, listItems: this.ensureAddPossible(data)}});
  }

  private updateRowValue(index:number, value:string) {
    if (this.state.listItems === undefined || this.state.listItems.length <= index) {
      return;
    }

    const currentValue = this.state.listItems[index].val;

    if (currentValue === value) {
      return; // no change
    }

    this.setState((state) => {
      const data = this.state.listItems.slice();
      data[index] = {val: value, format: this.state.listItems[index].format, key:this.state.listItems[index].key};
      return {...state, listItems: this.ensureAddPossible(data)}});
  }

  private getIcon(fileName: string) {
    return (
      <div onClick={() => this.setState({showIconList:false, showIconSelect:false, avatarId:undefined, icon:fileName})} key={fileName}>
        <img src={"logos/" + fileName} style={{width: '34px', height: '34px', backgroundColor: styleColors.softYellow, borderRadius: 100}}/>
      </div>);
  }

  private renderNoteItem(item:IListItem, index:number) {

    const slideRef: React.RefObject<HTMLDivElement> = React.createRef();

    return (
      <div className={this.props.classes.listHolder + (index===0&&this.state.bounceTopItem?(" "+this.props.classes.bounceRight):"")} 
        key={item.key} ref={slideRef}>
        <div className={this.props.classes.listRow} style={{maxHeight: item.deleted === true ? '0px' : '50px'}}>
          <div className={this.props.classes.listRowContent}>
            <input
              id={item.key}
              type="text"
              value={item.val}
              onChange={(event) => this.updateRowValue(index, event.target.value)}
              className={this.props.classes.listValue}
              style={item.format === 1
                  ? {textDecoration: 'line-through', color: styleColors.blackAlpha45}
                  : item.format === 2
                    ?{fontSize: '10px', padding: '32px 0px 0px', fontWeight: 700,}
                    :{}}
              autoCorrect="on"
              spellCheck={true}
              onClick={() => {if (slideRef.current) {slideRef.current.scrollLeft = 0; }}}
              autoComplete="on"
              {...{enterkeyhint: "enter"}}
              readOnly={item.format === 1 || item.deleted === true}
              maxLength={512}
              onBeforeInput={(event) => this.handleListBeforeInput(index, event)}
              onKeyDown={(event) => this.handleListKeyDown(index, event)}
              onKeyPress={(event) => this.handleListKeyPress(index, event)}
              onKeyUp={(event) => this.handleListKeyUp(index, event)}
              onPaste={(event) => this.pasteRows(index, event)}
              placeholder={item.deleted?"":tn.lang.addListTodo}
            />
           
            <IconButton
              onClick={() => this.crossRow(index)}
              style={item.format === 2
                ? {display: 'none'}
                : item.val.length === 0 
                  ? {opacity:0, pointerEvents: 'none'}
                  : {backgroundColor:(item.format === 1 ? primaryColor : theme.palette.grey[300])}}
              classes={{root: this.props.classes.checkButtonRoot}}>
              <Check fontSize="small" color="inherit" style={{width: 20, height: 20}}/>
            </IconButton>

          </div>
          {<div className={this.props.classes.listRowErase} onClick={() => {
            if (slideRef.current) {slideRef.current.scrollLeft = 0}
            this.deleteRow(index)}}>
            {tn.lang.erase}
          </div>}
        </div>
      </div>);
  }

  private copyToClipBoard(dataToCopy: string, htmlToCopy?:string ) {
    if (dataToCopy.length === 0) {
      return;
    }

    if (htmlToCopy && this.copyRichToClipboard(dataToCopy, htmlToCopy)) {
      return;
    }

    this.copyPlainTextToClipboard(dataToCopy);
  }

  private copyRichToClipboard(dataToCopy:string, htmlToCopy:string):boolean {
    const clipboard = navigator.clipboard as any;
    const clipboardItem = (window as any).ClipboardItem;
    if (!clipboard || !clipboard.write || !clipboardItem || typeof Blob === 'undefined') {
      return false;
    }

    try {
      const writeResult = clipboard.write([
        new clipboardItem({
          'text/plain': new Blob([dataToCopy], {type:'text/plain'}),
          'text/html': new Blob([htmlToCopy], {type:'text/html'}),
        }),
      ]);

      if (writeResult && typeof writeResult.then === 'function') {
        writeResult
          .then(() => this.props.displaySuccessMessage(tn.lang.copiedToClipboard))
          .catch(() => this.copyPlainTextToClipboard(dataToCopy));
        return true;
      }

      this.props.displaySuccessMessage(tn.lang.copiedToClipboard);
      return true;
    } catch (error) {
      return false;
    }
  }

  private copyPlainTextToClipboard(dataToCopy:string) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      try {
        const writeResult = navigator.clipboard.writeText(dataToCopy) as any;
        if (writeResult && typeof writeResult.then === 'function') {
          writeResult
            .then(() => this.props.displaySuccessMessage(tn.lang.copiedToClipboard))
            .catch(() => this.copyToClipboardFallback(dataToCopy));
          return;
        }

        this.props.displaySuccessMessage(tn.lang.copiedToClipboard);
        return;
      } catch (error) {
        this.copyToClipboardFallback(dataToCopy);
        return;
      }
    }

    this.copyToClipboardFallback(dataToCopy);
  }

  private copyToClipboardFallback(dataToCopy:string) {
    if (!document.body || !document.execCommand) {
      return;
    }

    const textarea = document.createElement('textarea');
    textarea.value = dataToCopy;
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    textarea.style.top = '0';
    const body = document.body;
    body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    try {
      if (document.execCommand('copy')) {
        this.props.displaySuccessMessage(tn.lang.copiedToClipboard);
      }
    } catch (error) {
      return;
    } finally {
      body.removeChild(textarea);
    }
  }

  private copyListToClipboard() {
    this.copyToClipBoard(
      formatSharedNoteListForClipboard(this.state.title, this.state.listItems),
      formatSharedNoteListHtmlForClipboard(this.state.title, this.state.listItems),
    );
  }

  private paneMoveStart(e: React.TouchEvent<HTMLDivElement>) {
    e.stopPropagation();
    if (!this.paneRef.current) return;
    this.isDragging = true;
    this.dragStartY = e.touches[0].clientY;
    this.dragStartHeight = this.paneRef.current.getBoundingClientRect().height;
    // turn off transitions during drag
    this.paneRef.current.style.transition = 'none';
  }

  private paneMove(e: React.TouchEvent<HTMLDivElement>) {
    e.preventDefault();
    e.stopPropagation();
    if (!this.isDragging || !this.paneRef.current) return;
    const currentY = e.touches[0].clientY;
    const delta = this.dragStartY - currentY;
    let newHeight = this.dragStartHeight + delta;
    // clamp between 0 and viewport height
    const maxH = window.innerHeight;
    newHeight = Math.max(0, Math.min(newHeight, maxH));
    this.paneHeight = `${newHeight}px`;
    if (delta < -250) {
      this.isDragging = false;
      this.paneRef.current.style.minHeight = '0%';
      this.paneRef.current.style.maxHeight = '0%';
      this.paneRef.current.style.height = '0%';
      this.paneRef.current.style.transition = 'all 0.3s';
      this.saveNote();
      this.props.close();
      if (this.hideRef.current) {
        this.hideRef.current.style.opacity = "0";
      }
    } else {
      this.paneRef.current.style.minHeight = this.paneHeight;
      this.paneRef.current.style.maxHeight = this.paneHeight;
      this.paneRef.current.style.height = this.paneHeight;
      if (this.hideRef.current) {
        const opacity = 1- Math.min(Math.max(0,(delta / -100)),1);
        this.hideRef.current.style.opacity = (opacity).toString();
      }
    }

  }

  private paneMoveEnd(e: React.TouchEvent<HTMLDivElement>) {
    e.stopPropagation();
    if (!this.paneRef.current) return;
    if (this.isDragging) {
      this.paneRef.current.style.minHeight = '100%';
      this.paneRef.current.style.maxHeight = '100%';
      this.paneRef.current.style.height = '100%';
    }

    this.isDragging = false;
    this.paneRef.current.style.transition = 'all 0.3s';
  }

  private undo() {
    if (this.state.history.length <= 1) {
      return;
    }
    const lastState = this.state.history[1];

    this.setState({
      title: lastState.serviceName,
      icon: lastState.icon,
      avatarId: lastState.avatarId,
      visibleFor: lastState.visibleFor,
      listItems: lastState.listItems?this.ensureKeyed(lastState.listItems):[],
      desc: lastState.text?lastState.text:"",
      hasDesc: lastState.text !== undefined && lastState.text.length > 0,
      accountPassword: lastState.accountPassword?lastState.accountPassword:"",
      accountUsername: lastState.accountName?lastState.accountName:"",
      undoPressed: true,
      history: this.state.history.slice(1)
    });

  }

}

function mapStateToProps(state: any) {
  const aiTasks:IAiTask[] = (state.event.aiTasks?state.event.aiTasks:[])
    .filter((i: IAiTask) => (i.taskType === AI_TASK_TYPE.NOTE && i.dismissed !== true));
  const aiIconTasks:IAiTask[] = (state.event.aiTasks?state.event.aiTasks:[])
    .filter((i: IAiTask) => (i.taskType === AI_TASK_TYPE.NOTE_ICON && i.dismissed !== true));


  return {
    aiTasks,
    aiIconTasks,
    uploadedFiles: state?.file?.uploadedFiles ? state.file.uploadedFiles : [],
  };
}

const mapDispatchToProps = {
  deleteSharedNote: SharedNoteActions.deleteSharedNote,
  seenSharedNote: SharedNoteActions.seenSharedNote,
  localDel: SharedNoteActions.localDel,
  localSave: SharedNoteActions.localSave,
  updateSharedNote: SharedNoteActions.updateSharedNote,
  aiTask: EventActions.aiTask,
  dismissAiTask : EventActions.dismissAiTask,
  uploadFile: FileActions.requestFileUpload,
  displaySuccessMessage,
};

const areEqualUnordered =(a: IListItem[], b: IListItem[]): boolean => {
  if (a.length !== b.length) return false;

  // Turn each item into a canonical string
  const normalize = (item: IListItem) =>
    JSON.stringify({
      val: item.val,
      // explicitly include format (or null) so missing/undefined formats compare the same
      format: item.format ?? null  
    });

  const sortedA = a.map(normalize).sort();
  const sortedB = b.map(normalize).sort();

  return sortedA.every((s, i) => s === sortedB[i]);
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(sharedMiscStyle)(SharedNote));



// WEBPACK FOOTER //
// ./src/components/sharednotes/SharedNote.tsx